import React, { useContext } from "react";
import { Col, Row, Button, Input } from "reactstrap";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import SubUserFilter from "./subUserFilter";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { Link } from "react-router-dom";
import { StateContext } from "../utils/context";
import { useTranslation } from "react-i18next";

const DisputeClaimsTable = ({ tableData, searchQuery, defaultSorted,   subUserData, }) => {
  const { currentUser } = useContext(StateContext);
  const { ExportCSVButton } = CSVExport;

  const {t} = useTranslation();

  const releaseFormatter = (cell, row) => {
    const SRC = row.release_artwork ? row.release_artwork.thumb_small : null;
    return (
        <Link to={`/releases/${row.release}/view/`}>
            <div className="flexContainer">
                {SRC && <img style={{width: 40, height: 40, borderRadius: '100%'}} src={SRC} alt={cell} /> }
                <p className="fontWeight700">{cell}</p>
            </div>
        </Link>
    );
  };

  const releaseCsvFormatter = (cell) => cell;

  const statusFormatter = cell => {
    return (
      <>
        {cell === "created" ? (
          <Button className="btn-status-big" disabled color="primary">
            {t("disputeClaims.view.table.label.status_created")}
          </Button>
        ) : cell === "pending" ? (
          <Button className="btn-status-big" disabled color="info">
            {t("disputeClaims.view.table.label.status_pending")}
          </Button>
        ) : cell === "in_progress" ? (
          <Button className="btn-status-big" disabled color="warning">
            {t("disputeClaims.view.table.label.status_in_progress")}
          </Button>
        ) : cell === "resolved" ? (
          <Button className="btn-status-big" disabled color="success">
            {t("disputeClaims.view.table.label.status_resolved")}
          </Button>
        ) : cell === "copyright_violation" ? (
          <Button className="btn-status-big"  disabled color="danger">
            {t("disputeClaims.view.table.label.status_copyright_violation")}
          </Button>
        ): null}
      </>
    );
  };

  const statusCsvFormatter = cell => {
    if (cell === "created") {
      return t("disputeClaims.view.table.label.status_created");
    } else if (cell === "pending") {
      return t("disputeClaims.view.table.label.status_pending");
    } else if (cell === "in_progress") {
      return t("disputeClaims.view.table.label.status_in_progress");
    } else if (cell === "resolved") {
      return t("disputeClaims.view.table.label.status_resolved");
    } else if (cell === "copyright_violation") {
      return t("disputeClaims.view.table.label.status_copyright_violation");
    } else {
      return null;
    }
  };

  const columns = [
    {
        dataField: "release_name",
        text: t("disputeClaims.view.table.columns.release"),
        formatter: releaseFormatter,
        csvFormatter: releaseCsvFormatter,
        sort: false,
        headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "release_owner",
      text: t("disputeClaims.view.table.columns.user"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      }
    },
    {
        dataField: "store",
        text: t("disputeClaims.view.table.columns.store"),
        sort: false,
        headerStyle: () => ({ width: "120px" })
    },
    {
        dataField: "claimant_name",
        text: t("disputeClaims.view.table.columns.claimantName"),
        sort: false,
        headerStyle: () => ({ width: "120px" })
    },
    {
        dataField: "claimant_email",
        text: t("disputeClaims.view.table.columns.claimantEmail"),
        sort: false,
        headerStyle: () => ({ width: "120px" })
    },
    {
        dataField: "resolution_time",
        text: t("disputeClaims.view.table.columns.resolutionTime"),
        sort: false,
        headerStyle: () => ({ width: "120px" })
    },
    {
        dataField: "time_remaining",
        text: t("disputeClaims.view.table.columns.remainingTime"),
        sort: false,
        headerStyle: () => ({ width: "120px" })
    },
    {
        dataField: "status",
        text: t("disputeClaims.view.table.columns.status"),
        formatter: statusFormatter,
        csvFormatter: statusCsvFormatter,
        sort: true,
        headerStyle: () => ({ width: "125px" })
    },
    {
      dataField: "release_name",
      sort: false,
      csvExport: false,
      hidden: true,
    }
  ];

  const handleTableChange = (type, { sortField, sortOrder }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "status") {
      searchQuery.setOrdering({ order: ascDesc, name: sortField, sort: sortField });
    }
  };

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={{ fileName: "dispute-claims.csv" }}
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="customSearch">
                <Input
                  placeholder={t("disputeClaims.view.table.placeholder.search")}
                  value={searchQuery.query}
                  style={{ marginBottom: 10 }}
                  onChange={e => searchQuery.setQuery(e.target.value)}
                />
              </div>
            </Col>
            {
                currentUser.is_premium_user && <SubUserFilter subUserData={subUserData} />
            }
            <Col>
              <div className="flexEndContainer">
                <ExportCSVButton className="btn btn-outline-info" {...props.csvProps}>
                  {t("disputeClaims.view.table.button.exportCSV")}
                </ExportCSVButton>
              </div>
            </Col>
          </Row>
          <BootstrapTable
            {...props.baseProps}
            bordered={false}
            remote={{ sort: true }}
            defaultSorted={defaultSorted}
            onTableChange={handleTableChange}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default DisputeClaimsTable;